import React from "react";
import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { BRAND, NAV_LINKS } from "@/lib/constants";
import { Phone, Mail } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const c = useContent();
  return (
  <footer className="border-t border-[#232f25] bg-[#0a0d0a] mt-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid gap-10 md:grid-cols-3">
      <div>
        <Brand size="md" showTagline />
        <p className="text-xs text-[#69776b] mt-4 max-w-xs leading-relaxed">
          {c.footer?.tagline}
        </p>
      </div>

      <div>
        <h4 className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#8CE63C] mb-3">Explore</h4>
        <ul className="space-y-2">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="text-sm text-[#9EABA0] hover:text-[#8CE63C] transition-colors">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#8CE63C] mb-3">Contact</h4>
        <a href={`tel:${c.contact?.phoneHref || BRAND.phoneHref}`} className="flex items-center gap-2 text-sm text-[#9EABA0] hover:text-[#8CE63C] transition-colors" data-testid="footer-phone">
          <Phone size={15} /> {c.contact?.phone || BRAND.phone}
        </a>
        <a href={`mailto:${c.contact?.email || BRAND.email}`} className="flex items-center gap-2 text-sm text-[#9EABA0] hover:text-[#8CE63C] transition-colors mt-2" data-testid="footer-email">
          <Mail size={15} /> {c.contact?.email || BRAND.email}
        </a>
        <Link to="/admin/login" data-testid="nav-admin-link" className="inline-block mt-5 text-[11px] font-semibold uppercase tracking-wide text-[#69776b] hover:text-[#8CE63C] transition-colors">
          Admin Login
        </Link>
      </div>
    </div>
    <div className="border-t border-[#232f25] py-5">
      <p className="text-center text-xs text-[#69776b]">
        © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
      </p>
    </div>
  </footer>
  );
};
